import React, { createContext, useContext } from 'react';
import { usePwaInstallFlow } from '../hooks/usePwaInstallFlow';

const PwaInstallContext = createContext(null);

export function PwaInstallProvider({ children }) {
  const flow = usePwaInstallFlow();

  return (
    <PwaInstallContext.Provider value={flow}>
      {flow.modals}
      {children}
    </PwaInstallContext.Provider>
  );
}

export function usePwaInstallContext() {
  const ctx = useContext(PwaInstallContext);
  if (!ctx) {
    throw new Error('usePwaInstallContext must be used within PwaInstallProvider');
  }
  return ctx;
}
